import { render, staticRenderFns } from "./CreateSitePage.vue?vue&type=template&id=5af7f84e&scoped=true"
import script from "./CreateSitePage.vue?vue&type=script&lang=js"
export * from "./CreateSitePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7f84e",
  null
  
)

export default component.exports